import { setTrack } from '@/api/login'

const bindings = new WeakMap()

// 显式标记需要统计的操作，避免自动采集输入内容和重复统计已有事件。
export default {
  mounted(el, binding) {
    const state = { value: binding.value }
    state.listener = (event) => {
      if ((event.type === 'auxclick' && event.button !== 1) || el.disabled || el.getAttribute('aria-disabled') === 'true') return
      const data = typeof state.value === 'string' ? { position: state.value } : state.value
      if (data?.position) void setTrack(data)
    }
    bindings.set(el, state)
    el.addEventListener('click', state.listener)
    el.addEventListener('auxclick', state.listener)
  },
  updated(el, binding) {
    const state = bindings.get(el)
    if (state) state.value = binding.value
  },
  unmounted(el) {
    const state = bindings.get(el)
    if (!state) return
    el.removeEventListener('click', state.listener)
    el.removeEventListener('auxclick', state.listener)
    bindings.delete(el)
  },
}
